import React from "react";
import { Arc, Circle, Group } from "react-konva";
import { ClockPoint } from "../ClockPoint";
var ACTIVE_COLOR = "#dd4e4e";
var INACTIVE_COLOR = "#dd9695";
var nullTranslation = {
  x: 0,
  y: 0
};
export function EditableHeatRange(_ref) {
  var range = _ref.range,
      index = _ref.index,
      clockRadius = _ref.clockRadius;
  var outOfBound = range.outOfBound,
      from = range.from,
      to = range.to,
      _range$translation = range.translation,
      translation = _range$translation === void 0 ? nullTranslation : _range$translation;
  return /*#__PURE__*/React.createElement(Group, translation, /*#__PURE__*/React.createElement(Arc, {
    stroke: outOfBound ? INACTIVE_COLOR : ACTIVE_COLOR,
    strokeWidth: 10,
    innerRadius: clockRadius,
    outerRadius: clockRadius,
    angle: to - from,
    rotation: from,
    listening: false
  }), /*#__PURE__*/React.createElement(ClockPoint, {
    as: Circle,
    angle: from,
    clockRadius: clockRadius,
    radius: 10,
    fill: outOfBound ? INACTIVE_COLOR : ACTIVE_COLOR,
    listening: false
  }), /*#__PURE__*/React.createElement(ClockPoint, {
    as: Circle,
    angle: to,
    clockRadius: clockRadius,
    radius: 10,
    fill: outOfBound ? INACTIVE_COLOR : ACTIVE_COLOR,
    listening: false
  }));
}